// eslint-disable-next-line import/prefer-default-export
export const SHOW_PUSH_NOTIFICATION_MODAL = 'SHOW_PUSH_NOTIFICATION_MODAL';
